export default "__VITE_PUBLIC_ASSET__32bfd8ec__"